import { createFileRoute } from "@tanstack/react-router";

import SignInPage from "@/admin/signin/page";

export const Route = createFileRoute("/signin")({
    // ssr: false 를 제거 — SignInPage/Form은 브라우저 API 없이 렌더 가능.
    // ssr: false 상태에서 서버는 children 자리를 빈 플레이스홀더로 내보내고
    // 클라이언트는 전체 페이지를 렌더하려 해서 hydration mismatch가 발생했음.
    component: RouteComponent,
});

function RouteComponent() {
    return <SignInPage />;
}
